// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabNew-module__font-s-10___PeAv6 {
  font-size: 10px !important;
}

.TabNew-module__font-s-12___sl8le {
  font-size: 12px !important;
}

.TabNew-module__font-s-13___P7Yvr {
  font-size: 13px !important;
}

.TabNew-module__font-s-14___uxgbb {
  font-size: 14px !important;
}

.TabNew-module__font-s-15___jGK3q {
  font-size: 15px !important;
}

.TabNew-module__font-s-16___KsdbY {
  font-size: 16px !important;
}

.TabNew-module__font-s-18___PsDP5 {
  font-size: 18px !important;
}

.TabNew-module__font-s-20___Zlghn {
  font-size: 20px !important;
}

.TabNew-module__font-s-22___Np93p {
  font-size: 22px !important;
}

.TabNew-module__font-s-28___RJ5tn {
  font-size: 28px !important;
}

.TabNew-module__font-w-400____Hg6H {
  font-weight: 400 !important;
}

.TabNew-module__font-w-500___OQOBM {
  font-weight: 500 !important;
}

.TabNew-module__font-w-600___e1_bK {
  font-weight: 600 !important;
}

.TabNew-module__font-w-700___imNf8 {
  font-weight: 700 !important;
}

.TabNew-module__p-5___Z_qy9 {
  padding: 5px !important;
}

.TabNew-module__p-12___mNWAK {
  padding: 12px !important;
}

.TabNew-module__p-16___jQruv {
  padding: 16px !important;
}

.TabNew-module__p-30___MqxVf {
  padding: 30px !important;
}

.TabNew-module__p-b-0___xzlph {
  padding-bottom: 0 !important;
}

.TabNew-module__p-b-5___NbQYV {
  padding-bottom: 5px !important;
}

.TabNew-module__p-b-10___AzDa0 {
  padding-bottom: 10px !important;
}

.TabNew-module__p-b-12____2L_4 {
  padding-bottom: 12px !important;
}

.TabNew-module__p-b-16___KDLLR {
  padding-bottom: 16px !important;
}

.TabNew-module__p-b-18___Aqutt {
  padding-bottom: 18px !important;
}

.TabNew-module__p-b-20___cuWEs {
  padding-bottom: 20px !important;
}

.TabNew-module__p-b-25___GeLja {
  padding-bottom: 25px !important;
}

.TabNew-module__p-b-30___luocO {
  padding-bottom: 30px !important;
}

.TabNew-module__p-b-50___sM46A {
  padding-bottom: 50px !important;
}

.TabNew-module__p-t-0___xOzyE {
  padding-top: 0 !important;
}

.TabNew-module__p-t-12___wEcY1 {
  padding-top: 12px !important;
}

.TabNew-module__p-t-16___zo9d_ {
  padding-top: 16px !important;
}

.TabNew-module__p-t-18___VyK37 {
  padding-top: 18px !important;
}

.TabNew-module__p-t-20___oLhOW {
  padding-top: 20px !important;
}

.TabNew-module__p-t-30___nb3R6 {
  padding-top: 30px !important;
}

.TabNew-module__p-t-40____1S8i {
  padding-top: 40px !important;
}

.TabNew-module__p-t-50___oiwd8 {
  padding-top: 50px !important;
}

.TabNew-module__p-l-20___sN0CH {
  padding-left: 20px !important;
}

.TabNew-module__p-l-30___OaVlk {
  padding-left: 30px !important;
}

.TabNew-module__p-l-40___llRM6 {
  padding-left: 40px !important;
}

.TabNew-module__p-r-16___c8Dp8 {
  padding-right: 16px !important;
}

.TabNew-module__p-r-20___ua14A {
  padding-right: 20px !important;
}

.TabNew-module__p-r-30___vDGnb {
  padding-right: 30px !important;
}

.TabNew-module__p-r-50___WrAcv {
  padding-right: 50px !important;
}

.TabNew-module__p-r-60___fVUEF {
  padding-right: 60px !important;
}

.TabNew-module__m-b-1___zUt1m {
  margin-bottom: 1px !important;
}

.TabNew-module__m-b-2___Vd4EZ {
  margin-bottom: 2px !important;
}

.TabNew-module__m-b-6____37qz {
  margin-bottom: 6px !important;
}

.TabNew-module__m-b-8___V8GY0 {
  margin-bottom: 8px !important;
}

.TabNew-module__m-b-10___fG6Zv {
  margin-bottom: 10px !important;
}

.TabNew-module__m-b-14___ZPngf {
  margin-bottom: 14px !important;
}

.TabNew-module__m-b-16___cUIq3 {
  margin-bottom: 16px !important;
}

.TabNew-module__m-b-20___wtkqF {
  margin-bottom: 20px !important;
}

.TabNew-module__m-b-22___12eUB {
  margin-bottom: 22px !important;
}

.TabNew-module__m-b-24___IWMMK {
  margin-bottom: 24px !important;
}

.TabNew-module__m-b-30___b11ja {
  margin-bottom: 30px !important;
}

.TabNew-module__m-b-32___caBCH {
  margin-bottom: 32px !important;
}

.TabNew-module__m-b-40___jWwlB {
  margin-bottom: 40px !important;
}

.TabNew-module__m-t-2___flLrO {
  margin-top: 2px !important;
}

.TabNew-module__m-t-3___sokgl {
  margin-top: 3px !important;
}

.TabNew-module__m-t-4___nrVaR {
  margin-top: 4px !important;
}

.TabNew-module__m-t-5___AHKvV {
  margin-top: 5px !important;
}

.TabNew-module__m-t-8___r_H3Y {
  margin-top: 8px !important;
}

.TabNew-module__m-t-10___cE0ia {
  margin-top: 10px !important;
}

.TabNew-module__m-t-15___YgM25 {
  margin-top: 15px !important;
}

.TabNew-module__m-t-16___mskF8 {
  margin-top: 16px !important;
}

.TabNew-module__m-t-20___vpXNW {
  margin-top: 20px !important;
}

.TabNew-module__m-t-22___ZS5uo {
  margin-top: 22px !important;
}

.TabNew-module__m-t-30___zyXfm {
  margin-top: 30px !important;
}

.TabNew-module__m-t-32___Q5uMz {
  margin-top: 32px !important;
}

.TabNew-module__m-l-auto___wHGNn {
  margin-left: auto !important;
}

.TabNew-module__m-l-4___wIasS {
  margin-left: 4px !important;
}

.TabNew-module__m-l-5___mPnrj {
  margin-left: 5px !important;
}

.TabNew-module__m-l-6___LAy_d {
  margin-left: 6px !important;
}

.TabNew-module__m-l-8___oFFxE {
  margin-left: 8px !important;
}

.TabNew-module__m-l-10___uYuoI {
  margin-left: 10px !important;
}

.TabNew-module__m-l-16___kHwVj {
  margin-left: 16px !important;
}

.TabNew-module__m-l-20___sBnvB {
  margin-left: 20px !important;
}

.TabNew-module__m-l-24___xmvSj {
  margin-left: 24px !important;
}

.TabNew-module__m-l-30___I_oAw {
  margin-left: 30px !important;
}

.TabNew-module__m-l-35___dIfWF {
  margin-left: 35px !important;
}

.TabNew-module__m-l-40___BNMZq {
  margin-left: 40px !important;
}

.TabNew-module__m-r-8___v8pZ8 {
  margin-right: 8px !important;
}

.TabNew-module__m-r-10___F2C4A {
  margin-right: 10px !important;
}

.TabNew-module__m-r-16___W_V44 {
  margin-right: 16px !important;
}

.TabNew-module__m-r-20___Athvx {
  margin-right: 20px !important;
}

.TabNew-module__m-r-24___aagDj {
  margin-right: 24px !important;
}

.TabNew-module__m-r-30___ykJwZ {
  margin-right: 30px !important;
}

.TabNew-module__m-r-40___WCKx8 {
  margin-right: 40px !important;
}

.TabNew-module__border-r-3___hT7tp {
  border-radius: 3px !important;
}

.TabNew-module__border-r-4____RLyj {
  border-radius: 4px !important;
}

.TabNew-module__border-r-6___W_iwg {
  border-radius: 6px !important;
}

.TabNew-module__border-r-10___eZzNJ {
  border-radius: 10px !important;
}

.TabNew-module__border-r-12___xDOO0 {
  border-radius: 12px !important;
}

.TabNew-module__border-r-16___EGjxc {
  border-radius: 16px !important;
}

.TabNew-module__border-r-50___xcMxY {
  border-radius: 50% !important;
}

.TabNew-module__primary-border___LW3rs {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TabNew-module__primary-border-b___qQk60 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TabNew-module__primary-border-t___sXzEO {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TabNew-module__primary-border-l___MMHrj {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TabNew-module__primary-border-r___tkJ0S {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TabNew-module__secondary-border___airNZ {
  border: 1px solid #637768;
}

.TabNew-module__secondary-border-b___i3ZUi {
  border-bottom: 1px solid #637768;
}

.TabNew-module__secondary-border-t___OhuF6 {
  border-top: 1px solid #637768;
}

.TabNew-module__secondary-border-l___gAYtO {
  border-left: 1px solid #637768;
}

.TabNew-module__secondary-border-r___ZIN91 {
  border-right: 1px solid #637768;
}

.TabNew-module__gap-0___ghOS4 {
  gap: 0 !important;
}

.TabNew-module__gap-2___S28zD {
  gap: 2px !important;
}

.TabNew-module__gap-4___BgwZP {
  gap: 4px !important;
}

.TabNew-module__gap-5___nxyqT {
  gap: 5px !important;
}

.TabNew-module__gap-6___XIB7z {
  gap: 6px !important;
}

.TabNew-module__gap-8___FbpUg {
  gap: 8px !important;
}

.TabNew-module__gap-10___kWSNY {
  gap: 10px !important;
}

.TabNew-module__gap-12___THOPK {
  gap: 12px !important;
}

.TabNew-module__gap-14___BIWA6 {
  gap: 14px !important;
}

.TabNew-module__gap-16___c8_vS {
  gap: 16px !important;
}

.TabNew-module__gap-18___acRQK {
  gap: 18px !important;
}

.TabNew-module__gap-20___Rw96t {
  gap: 20px !important;
}

.TabNew-module__gap-24___gA_uf {
  gap: 24px !important;
}

.TabNew-module__gap-26___TYYqs {
  gap: 26px !important;
}

.TabNew-module__gap-30___nG2OQ {
  gap: 30px !important;
}

.TabNew-module__gap-32___WojVz {
  gap: 32px !important;
}

.TabNew-module__gap-40___tzx1k {
  gap: 40px !important;
}

.TabNew-module__gap-50___BUUII {
  gap: 50px !important;
}

.TabNew-module__flex-1___fGIIf {
  flex: 1;
}

.TabNew-module__flex-none___sudgV {
  flex: none !important;
}

.TabNew-module__flex-column___rr8sG {
  display: flex;
  flex-direction: column !important;
}

.TabNew-module__flex-row___GBaeW {
  display: flex;
  flex-direction: row !important;
}

.TabNew-module__vertically-centered___lvgyB {
  display: flex;
  align-items: center !important;
}

.TabNew-module__horizontally-centered___q6R_O {
  display: flex;
  justify-content: center !important;
}

.TabNew-module__horizontally-end___f4CrD {
  display: flex;
  justify-content: end !important;
}

.TabNew-module__vertically-start___hUoMZ {
  display: flex;
  align-items: start !important;
}

.TabNew-module__space-between___JZWxt {
  display: flex;
  justify-content: space-between !important;
}

.TabNew-module__flex-wrap___oap8C {
  flex-wrap: wrap !important;
}

.TabNew-module__height-100___yUC7J {
  height: 100%;
}

.TabNew-module__width-50___npPcl {
  width: 50% !important;
}

.TabNew-module__width-100___RXg2D {
  width: 100%;
}

.TabNew-module__cursor-pointer___ySYcI {
  cursor: pointer;
}

.TabNew-module__cursor-not-allowed___W2sJC {
  cursor: not-allowed !important;
}

.TabNew-module__absolute-centered___dm4Wz {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TabNew-module__absolute___vDp8V {
  position: absolute;
}

.TabNew-module__relative___l5yhE {
  position: relative;
}

.TabNew-module__fixed___Gp2Ma {
  position: fixed;
}

.TabNew-module__visible___dmRXp {
  opacity: 1;
}

.TabNew-module__invisible___amu6b {
  opacity: 0;
}

.TabNew-module__col-90___UJJQ6 {
  width: 90% !important;
}

.TabNew-module__col-auto___p1yLK {
  width: auto !important;
}

.TabNew-module__medical-tabs___bU3nk {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TabNew-module__medical-table-new___Sz7rC {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TabNew-module__medical-table-new___Sz7rC:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TabNew-module__medical-table-new___Sz7rC::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TabNew-module__medical-table-new___Sz7rC::-webkit-scrollbar-track {
  display: none;
}
.TabNew-module__medical-table-new___Sz7rC.TabNew-module__no-pagination___PqhuE {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TabNew-module__medical-table-new___Sz7rC.TabNew-module__no-pagination___PqhuE:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TabNew-module__medical-table-new___Sz7rC.TabNew-module__no-pagination___PqhuE::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TabNew-module__medical-table-new___Sz7rC.TabNew-module__no-pagination___PqhuE::-webkit-scrollbar-track {
  display: none;
}

.TabNew-module__medical-table-empty___m5YgB {
  padding: 14px 40px !important;
}

.TabNew-module__icon-btn___gl_79 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TabNew-module__search-icon___dPUef {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TabNew-module__disable-select___qG7dq {
  user-select: none;
}

.TabNew-module__break-word___hRGF9 {
  word-break: break-word;
}

.TabNew-module__popup-clear-btn___h1TEw {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TabNew-module__scroll-m-b-20___i_cvv {
  scroll-margin-bottom: 20px;
}

.TabNew-module__tabContainer___CO2z8 {
  display: block;
  min-width: 100px;
}
.TabNew-module__tabContainer___CO2z8 .TabNew-module__text___aYJEh {
  font-family: var(--font-family);
  font-weight: 400;
  color: #637768;
}
.TabNew-module__tabContainer___CO2z8 .TabNew-module__text___aYJEh.TabNew-module__selected___m3qb_ {
  font-family: var(--font-family);
  font-weight: 700;
  color: #375844;
}
.TabNew-module__tabContainer___CO2z8 .TabNew-module__line___yGBcg {
  display: flex;
  width: 100%;
  height: 4px;
  background-color: #f1bf72;
  margin-top: 11px;
  opacity: 0;
  border-radius: 13px;
  transition: opacity 0.4s ease;
}
.TabNew-module__tabContainer___CO2z8 .TabNew-module__line___yGBcg.TabNew-module__visible___dmRXp {
  opacity: 1;
}
.TabNew-module__tabContainer___CO2z8 .TabNew-module__line___yGBcg.TabNew-module__withBadge___fBxHc {
  width: calc(100% + 10px);
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/tabs/TabNew/TabNew.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,gBAAA;AA8pBF;AA5pBE;EEoBA,+BApBO;EAqBP,gBCzBQ;EHMN,cAAA;AA+pBJ;AA7pBI;EEgBF,+BApBO;EAqBP,gBCtBK;EHOD,cAAA;AAgqBN;AA5pBE;EACE,aAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;AA8pBJ;AA5pBI;EACE,UAAA;AA8pBN;AA3pBI;EACE,wBAAA;AA6pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.tabContainer {\n  display: block;\n  min-width: 100px;\n\n  .text {\n    @include get-font($roboto, $regular);\n    color: get-color(greenNew, medium-dark);\n\n    &.selected {\n      @include get-font($roboto, $bold);\n      color: get-color(greenNew, dark);\n    }\n  }\n\n  .line {\n    display: flex;\n    width: 100%;\n    height: 4px;\n    background-color: #f1bf72;\n    margin-top: 11px;\n    opacity: 0;\n    border-radius: 13px;\n    transition: opacity 0.4s ease;\n\n    &.visible {\n      opacity: 1;\n    }\n\n    &.withBadge {\n      width: calc(100% + 10px);\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TabNew-module__font-s-10___PeAv6`,
	"fontS12": `TabNew-module__font-s-12___sl8le`,
	"fontS13": `TabNew-module__font-s-13___P7Yvr`,
	"fontS14": `TabNew-module__font-s-14___uxgbb`,
	"fontS15": `TabNew-module__font-s-15___jGK3q`,
	"fontS16": `TabNew-module__font-s-16___KsdbY`,
	"fontS18": `TabNew-module__font-s-18___PsDP5`,
	"fontS20": `TabNew-module__font-s-20___Zlghn`,
	"fontS22": `TabNew-module__font-s-22___Np93p`,
	"fontS28": `TabNew-module__font-s-28___RJ5tn`,
	"fontW400": `TabNew-module__font-w-400____Hg6H`,
	"fontW500": `TabNew-module__font-w-500___OQOBM`,
	"fontW600": `TabNew-module__font-w-600___e1_bK`,
	"fontW700": `TabNew-module__font-w-700___imNf8`,
	"p5": `TabNew-module__p-5___Z_qy9`,
	"p12": `TabNew-module__p-12___mNWAK`,
	"p16": `TabNew-module__p-16___jQruv`,
	"p30": `TabNew-module__p-30___MqxVf`,
	"pB0": `TabNew-module__p-b-0___xzlph`,
	"pB5": `TabNew-module__p-b-5___NbQYV`,
	"pB10": `TabNew-module__p-b-10___AzDa0`,
	"pB12": `TabNew-module__p-b-12____2L_4`,
	"pB16": `TabNew-module__p-b-16___KDLLR`,
	"pB18": `TabNew-module__p-b-18___Aqutt`,
	"pB20": `TabNew-module__p-b-20___cuWEs`,
	"pB25": `TabNew-module__p-b-25___GeLja`,
	"pB30": `TabNew-module__p-b-30___luocO`,
	"pB50": `TabNew-module__p-b-50___sM46A`,
	"pT0": `TabNew-module__p-t-0___xOzyE`,
	"pT12": `TabNew-module__p-t-12___wEcY1`,
	"pT16": `TabNew-module__p-t-16___zo9d_`,
	"pT18": `TabNew-module__p-t-18___VyK37`,
	"pT20": `TabNew-module__p-t-20___oLhOW`,
	"pT30": `TabNew-module__p-t-30___nb3R6`,
	"pT40": `TabNew-module__p-t-40____1S8i`,
	"pT50": `TabNew-module__p-t-50___oiwd8`,
	"pL20": `TabNew-module__p-l-20___sN0CH`,
	"pL30": `TabNew-module__p-l-30___OaVlk`,
	"pL40": `TabNew-module__p-l-40___llRM6`,
	"pR16": `TabNew-module__p-r-16___c8Dp8`,
	"pR20": `TabNew-module__p-r-20___ua14A`,
	"pR30": `TabNew-module__p-r-30___vDGnb`,
	"pR50": `TabNew-module__p-r-50___WrAcv`,
	"pR60": `TabNew-module__p-r-60___fVUEF`,
	"mB1": `TabNew-module__m-b-1___zUt1m`,
	"mB2": `TabNew-module__m-b-2___Vd4EZ`,
	"mB6": `TabNew-module__m-b-6____37qz`,
	"mB8": `TabNew-module__m-b-8___V8GY0`,
	"mB10": `TabNew-module__m-b-10___fG6Zv`,
	"mB14": `TabNew-module__m-b-14___ZPngf`,
	"mB16": `TabNew-module__m-b-16___cUIq3`,
	"mB20": `TabNew-module__m-b-20___wtkqF`,
	"mB22": `TabNew-module__m-b-22___12eUB`,
	"mB24": `TabNew-module__m-b-24___IWMMK`,
	"mB30": `TabNew-module__m-b-30___b11ja`,
	"mB32": `TabNew-module__m-b-32___caBCH`,
	"mB40": `TabNew-module__m-b-40___jWwlB`,
	"mT2": `TabNew-module__m-t-2___flLrO`,
	"mT3": `TabNew-module__m-t-3___sokgl`,
	"mT4": `TabNew-module__m-t-4___nrVaR`,
	"mT5": `TabNew-module__m-t-5___AHKvV`,
	"mT8": `TabNew-module__m-t-8___r_H3Y`,
	"mT10": `TabNew-module__m-t-10___cE0ia`,
	"mT15": `TabNew-module__m-t-15___YgM25`,
	"mT16": `TabNew-module__m-t-16___mskF8`,
	"mT20": `TabNew-module__m-t-20___vpXNW`,
	"mT22": `TabNew-module__m-t-22___ZS5uo`,
	"mT30": `TabNew-module__m-t-30___zyXfm`,
	"mT32": `TabNew-module__m-t-32___Q5uMz`,
	"mLAuto": `TabNew-module__m-l-auto___wHGNn`,
	"mL4": `TabNew-module__m-l-4___wIasS`,
	"mL5": `TabNew-module__m-l-5___mPnrj`,
	"mL6": `TabNew-module__m-l-6___LAy_d`,
	"mL8": `TabNew-module__m-l-8___oFFxE`,
	"mL10": `TabNew-module__m-l-10___uYuoI`,
	"mL16": `TabNew-module__m-l-16___kHwVj`,
	"mL20": `TabNew-module__m-l-20___sBnvB`,
	"mL24": `TabNew-module__m-l-24___xmvSj`,
	"mL30": `TabNew-module__m-l-30___I_oAw`,
	"mL35": `TabNew-module__m-l-35___dIfWF`,
	"mL40": `TabNew-module__m-l-40___BNMZq`,
	"mR8": `TabNew-module__m-r-8___v8pZ8`,
	"mR10": `TabNew-module__m-r-10___F2C4A`,
	"mR16": `TabNew-module__m-r-16___W_V44`,
	"mR20": `TabNew-module__m-r-20___Athvx`,
	"mR24": `TabNew-module__m-r-24___aagDj`,
	"mR30": `TabNew-module__m-r-30___ykJwZ`,
	"mR40": `TabNew-module__m-r-40___WCKx8`,
	"borderR3": `TabNew-module__border-r-3___hT7tp`,
	"borderR4": `TabNew-module__border-r-4____RLyj`,
	"borderR6": `TabNew-module__border-r-6___W_iwg`,
	"borderR10": `TabNew-module__border-r-10___eZzNJ`,
	"borderR12": `TabNew-module__border-r-12___xDOO0`,
	"borderR16": `TabNew-module__border-r-16___EGjxc`,
	"borderR50": `TabNew-module__border-r-50___xcMxY`,
	"primaryBorder": `TabNew-module__primary-border___LW3rs`,
	"primaryBorderB": `TabNew-module__primary-border-b___qQk60`,
	"primaryBorderT": `TabNew-module__primary-border-t___sXzEO`,
	"primaryBorderL": `TabNew-module__primary-border-l___MMHrj`,
	"primaryBorderR": `TabNew-module__primary-border-r___tkJ0S`,
	"secondaryBorder": `TabNew-module__secondary-border___airNZ`,
	"secondaryBorderB": `TabNew-module__secondary-border-b___i3ZUi`,
	"secondaryBorderT": `TabNew-module__secondary-border-t___OhuF6`,
	"secondaryBorderL": `TabNew-module__secondary-border-l___gAYtO`,
	"secondaryBorderR": `TabNew-module__secondary-border-r___ZIN91`,
	"gap0": `TabNew-module__gap-0___ghOS4`,
	"gap2": `TabNew-module__gap-2___S28zD`,
	"gap4": `TabNew-module__gap-4___BgwZP`,
	"gap5": `TabNew-module__gap-5___nxyqT`,
	"gap6": `TabNew-module__gap-6___XIB7z`,
	"gap8": `TabNew-module__gap-8___FbpUg`,
	"gap10": `TabNew-module__gap-10___kWSNY`,
	"gap12": `TabNew-module__gap-12___THOPK`,
	"gap14": `TabNew-module__gap-14___BIWA6`,
	"gap16": `TabNew-module__gap-16___c8_vS`,
	"gap18": `TabNew-module__gap-18___acRQK`,
	"gap20": `TabNew-module__gap-20___Rw96t`,
	"gap24": `TabNew-module__gap-24___gA_uf`,
	"gap26": `TabNew-module__gap-26___TYYqs`,
	"gap30": `TabNew-module__gap-30___nG2OQ`,
	"gap32": `TabNew-module__gap-32___WojVz`,
	"gap40": `TabNew-module__gap-40___tzx1k`,
	"gap50": `TabNew-module__gap-50___BUUII`,
	"flex1": `TabNew-module__flex-1___fGIIf`,
	"flexNone": `TabNew-module__flex-none___sudgV`,
	"flexColumn": `TabNew-module__flex-column___rr8sG`,
	"flexRow": `TabNew-module__flex-row___GBaeW`,
	"verticallyCentered": `TabNew-module__vertically-centered___lvgyB`,
	"horizontallyCentered": `TabNew-module__horizontally-centered___q6R_O`,
	"horizontallyEnd": `TabNew-module__horizontally-end___f4CrD`,
	"verticallyStart": `TabNew-module__vertically-start___hUoMZ`,
	"spaceBetween": `TabNew-module__space-between___JZWxt`,
	"flexWrap": `TabNew-module__flex-wrap___oap8C`,
	"height100": `TabNew-module__height-100___yUC7J`,
	"width50": `TabNew-module__width-50___npPcl`,
	"width100": `TabNew-module__width-100___RXg2D`,
	"cursorPointer": `TabNew-module__cursor-pointer___ySYcI`,
	"cursorNotAllowed": `TabNew-module__cursor-not-allowed___W2sJC`,
	"absoluteCentered": `TabNew-module__absolute-centered___dm4Wz`,
	"absolute": `TabNew-module__absolute___vDp8V`,
	"relative": `TabNew-module__relative___l5yhE`,
	"fixed": `TabNew-module__fixed___Gp2Ma`,
	"visible": `TabNew-module__visible___dmRXp`,
	"invisible": `TabNew-module__invisible___amu6b`,
	"col90": `TabNew-module__col-90___UJJQ6`,
	"colAuto": `TabNew-module__col-auto___p1yLK`,
	"medicalTabs": `TabNew-module__medical-tabs___bU3nk`,
	"medicalTableNew": `TabNew-module__medical-table-new___Sz7rC`,
	"noPagination": `TabNew-module__no-pagination___PqhuE`,
	"medicalTableEmpty": `TabNew-module__medical-table-empty___m5YgB`,
	"iconBtn": `TabNew-module__icon-btn___gl_79`,
	"searchIcon": `TabNew-module__search-icon___dPUef`,
	"disableSelect": `TabNew-module__disable-select___qG7dq`,
	"breakWord": `TabNew-module__break-word___hRGF9`,
	"popupClearBtn": `TabNew-module__popup-clear-btn___h1TEw`,
	"scrollMB20": `TabNew-module__scroll-m-b-20___i_cvv`,
	"tabContainer": `TabNew-module__tabContainer___CO2z8`,
	"text": `TabNew-module__text___aYJEh`,
	"selected": `TabNew-module__selected___m3qb_`,
	"line": `TabNew-module__line___yGBcg`,
	"withBadge": `TabNew-module__withBadge___fBxHc`
};
module.exports = ___CSS_LOADER_EXPORT___;
